import React, {useCallback, useEffect, useState} from 'react';
import {connect} from "react-redux";
import debounce from "lodash/debounce";

import Pager2 from "../../../PageLayout/Pager2";
import WizardPopupContext, {useCustomContext, wizardPopupAction} from "../WizardPopupContext";
import {getFabricators} from "../../../Fabricators/FabricatorsActions";
import WizardClonePopupFabricatorsList from "./WizardClonePopupFabricatorsList";
import {AccessRights} from "../../../../schemas/accessRightsModel";
import {getEnabledEntities} from "../../../../actions/customers";
import WizardClonePopupContentWhenCloning from "./WizardClonePopupContentWhenCloning";
import RadioList from '../../../Generic/radioList';


const WizardClonePopupContent = (props) => {

  const {totalPages, getFabricators, isSiteAdmin, getEnabledEntities, wizardCloneIsVisible} = props;
  const {wizardPopupState, wizardPopupDispatch} = useCustomContext(WizardPopupContext);
  const {searchText} = wizardPopupState;

  const [inputText, setInputText] = useState("");
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const fabricatorRequest = async () => {
    setIsLoading(true);
    if (isSiteAdmin) {
      await getEnabledEntities(page, searchText)
    } else {
      await getFabricators(page, 50, searchText);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    fabricatorRequest();
  }, [page, searchText]);

  const searchInputChange = (eventText) => {
    wizardPopupDispatch({
      type: wizardPopupAction,
      payload: {
        searchText: eventText
      }
    })
  }

  const onChangeCloningMode = (item) => {
    wizardPopupDispatch({
      type: wizardPopupAction,
      payload: {
        mode: item.value
      }
    })
  }

  const debouncedFunc = (eventText) => {
    return searchInputChange(eventText) // redux func
  }

  const debouncedChangeHandler = useCallback(debounce(debouncedFunc, 500), []);

  const handleInputChange = async (event) => {
    setInputText(event.target.value);
    await debouncedChangeHandler(event.target.value)
  }

  if (wizardCloneIsVisible) {
    return <WizardClonePopupContentWhenCloning/>
  }

  return (
    <div className="wizard-popup">
      <div className="fabricators-popup-search ">
        <input className={"fabricators-popup-search__input" + (inputText ? ' fabricators-popup-search__input--with-text' : '')}
          placeholder={"Search"} value={inputText} onChange={handleInputChange}/>
      </div>
      {isLoading ? <div className="ui-loader"/> : <WizardClonePopupFabricatorsList/>}
      <Pager2 totalPages={totalPages} page={page} pageClick={(newPage) => setPage(newPage)}/>
      <div>
        Features Cloning Mode: 
      <RadioList items={[{text: "Target", value: "target", selected: true}, {text: "Source", value: "source"}]}
                         onSelect={(item) => onChangeCloningMode(item)}
              />
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {fabricators} = store;
  const AR = AccessRights.get(store);
  const isSiteAdmin = AR.isSiteAdmin(true);
  const {enabledEntities} = store.customers;
  const {wizardCloneLogic} = store.wizardState;
  const {visible} = wizardCloneLogic;

  return {
    page: isSiteAdmin ? enabledEntities.data.page : fabricators.data.page,
    totalPages: isSiteAdmin ? enabledEntities.data.totalPages : fabricators.data.totalPages,
    isSiteAdmin: AR.isSiteAdmin(true),
    wizardCloneIsVisible: visible,
  };
};

const mapDispatchToProps = {
  getFabricators,
  getEnabledEntities,
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardClonePopupContent)
